import { FieldArray } from 'formik'
import { useCallback, useMemo } from 'react'
import { arrayToObject } from '~/common/arrayUtils2'
import { useMsg } from '~/common/localizationUtils'
import { Formulas, getFormulae } from '~/custom_reports/builder/calculated_fields/Formulae'
import { Box, Button, IconButton, Stack, Table, Tbody, Td, Th, Thead, Tr } from '~/design_system'
import { PlusO, Trash } from '~/icons'
import { DatasetFieldInput, DatasetInput } from '../FormFields'

export const FieldSelector = ({ calculatedField, maxFields = 2, types }) => {
  const msg = useMsg()
  const PermittedFieldPredicateLookup = useMemo(
    () =>
      arrayToObject(
        Formulas,
        f => f,
        f => getFormulae(msg)[f]
      ),
    [msg]
  )

  const PermittedFieldPredicate = useCallback(
    (field, types, id) =>
      (!types || types.indexOf(field.type) !== -1 || types.indexOf(field.data_type) !== -1) &&
      !PermittedFieldPredicateLookup[field.formula]?.usageLimitations?.formulaFieldDisallowed &&
      field.id !== id,
    [PermittedFieldPredicateLookup]
  )

  return (
    <FieldArray
      name="fields"
      render={arrayHelpers => (
        <Stack spacing={4}>
          <Table>
            <Thead>
              <Tr>
                <Th w="50%">Source</Th>
                <Th w="45%">Value</Th>
                <Th w="5%" />
              </Tr>
            </Thead>
            <Tbody>
              {calculatedField.fields?.map((field, index) => (
                <Tr key={field.id || `field.${index}`}>
                  <Td data-testid="path">
                    <DatasetInput
                      field={field}
                      name={`fields.${index}.path`}
                      datasetFields
                      calculated
                      parameters
                      systemVariables
                      onChange={datasetOption =>
                        arrayHelpers.replace(index, { path: datasetOption.value, field: null })
                      }
                    />
                  </Td>
                  <Td data-testid="field">
                    <DatasetFieldInput
                      field={field}
                      name={`fields.${index}.field`}
                      exclude={[field.id]}
                      predicate={f => PermittedFieldPredicate(f, types, calculatedField.id)}
                    />
                  </Td>
                  <Td>
                    <IconButton
                      type="button"
                      variant="deleteSecondary"
                      data-testid="delete"
                      icon={<Trash />}
                      aria-label={msg('common.ui.delete')}
                      onClick={() => arrayHelpers.remove(index)}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
          <Box>
            <Button
              type="button"
              data-testid="add"
              leftIcon={<PlusO />}
              onClick={() => arrayHelpers.push({ field: null, path: null })}
              isDisabled={calculatedField.fields.length >= maxFields}>
              Add Value
            </Button>
          </Box>
        </Stack>
      )}
    />
  )
}
